define('CheckoutDocumentUpload.Summary.View', [
    'Wizard.StepModule',
    'snapshot_checkoutdocumentupload_summary.tpl',
    'underscore'
], function (
    WizardStepModule,
    checkoutDocumentUploadSummaryTpl,
    _
) {
    'use strict';

    var StepModule = WizardStepModule['__esModule'] ? WizardStepModule['WizardStepModule'] : WizardStepModule;

    return StepModule.extend({

        template: checkoutDocumentUploadSummaryTpl,

        getContext: function () {
            var files = (this.model && this.model.get('__documentFiles')) || [];
            return {
                files:    files,
                hasFiles: files.length > 0
            };
        },

        isActive: function () {
            var files = (this.model && this.model.get('__documentFiles')) || [];
            return files.length > 0;
        }

    });
});
